import { Settings, WidgetData } from "./data"
import { Widget } from "./widget"

export type HeadingData = WidgetData & {
  settings: Settings & {
    title: string,
    header_size: string,
  },
  widgetType: "heading"
}

export class HeadingWidget extends Widget {
  title: string
  htmlTag: string

  constructor(data: HeadingData) {
    super(data);
    this.title = data.settings.title;
    this.htmlTag = data.settings.header_size;
  }
}
